import styled, { css } from 'styled-components';

export const InfoTextContainer = styled.div`
    font-family: "museo sans";
    font-weight: 300;
    font-size: 12px;
    line-height: 18px;
    
    ${props => css`
        color: ${props.color}
    `}




`;